import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/sk';

import antdCsLocale from 'antd/locale/cs_CZ';
import antdDeLocale from 'antd/locale/de_DE';
import antdSkLocale from 'antd/locale/sk_SK';
import { LOCAL_TRANSLATION_ROOT, PRODUCTION_TRANSLATION_ROOT } from 'app_config';
import { isProduction } from 'helpers/environmentHelpers';
import type { InitOptions } from 'i18next';
import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

export const DEFAULT_LANGUAGE = 'cs';
export const SUPPORTED_LANGUAGES: SUPPORTED_LANGUAGES_TYPE[] = ['en', 'cs', 'sk', 'de'];

export type SUPPORTED_LANGUAGES_TYPE = 'en' | 'cs' | 'sk' | 'de';

export const getAntdLocale = (lang?: string) => {
  if (lang === 'cs') {
    return antdCsLocale;
  }

  if (lang === 'sk') {
    return antdSkLocale;
  }

  if (lang === 'de') {
    return antdDeLocale;
  }

  return undefined; // English is default
};

export const SUPPORTED_NAMESPACES = [
  'common_old',
  'audit',
  'common',
  'dashboard',
  'inputs',
  'errors',
  'order',
  'serviceObject',
  'intervention',
  'request',
  'company',
  'reports',
  'customer',
  'permissions',
  'customForm',
  'material',
  'settings',
  'supportTicket',
  'subscriptions',
  'announcements'
];

const options: InitOptions = {
  lng: 'cs',
  fallbackLng: isProduction() ? DEFAULT_LANGUAGE : undefined,
  ns: SUPPORTED_NAMESPACES,
  defaultNS: 'common_old',
  backend: {
    backends: [
      HttpBackend,
      resourcesToBackend((lng: string, ns: string) => import(`./translations/${ns}/${lng}.json`))
    ],
    backendOptions: [
      {
        loadPath: `${
          import.meta.env.PROD ? PRODUCTION_TRANSLATION_ROOT : LOCAL_TRANSLATION_ROOT
        }/{{ns}}/{{lng}}.json${import.meta.env.DEV ? `?v=${Date.now()}` : ''}`
      }
    ]
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  debug: !isProduction(),

  appendNamespaceToMissingKey: true,
  parseMissingKeyHandler: (key: string) => `?_${key}_?`,

  interpolation: {
    escapeValue: false
  },

  react: {
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    nsMode: 'default',
    useSuspense: true
  }
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).use(ChainedBackend).use(I18nextBrowserLanguageDetector).init(options);

export { i18n as i18nInit };
